import React, {
  useRef,
  useState,
  Component
} from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from 'react-router';
import {connect} from "react-redux";
import * as Icon from 'react-feather';
// import { useDispatch, useSelector } from 'react-redux';
// import { useSnackbar } from 'notistack';
import {
  Avatar,
  // Box,
  ButtonBase,
  Hidden,
  Menu,
  IconButton,
  MenuItem,
  Typography,
  // makeStyles
} from '@material-ui/core';
import settings from '../../../../../images/003-user-1.png'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
// import { logout } from 'src/actions/accountActions';

// const classes = {
//   avatar: {
//     height: 32,
//     width: 32,
//     marginRight: '10px'
//   },
//   popover: {
//     width: 200
//   }
// };

// const ref = useRef(null);
//   // const dispatch = useDispatch();
//   // const account = useSelector((state) => state.account);
//   // const { enqueueSnackbar } = useSnackbar();
//   // const [isOpen, setOpen] = useState(false);



//   const handleClose = () => {
//     setOpen(false);
//   };

//   const handleLogout = async () => {
//     try {
//       handleClose();
//       // await dispatch(logout());
//       // history.push('/');
//     } catch (error) {
//       // enqueueSnackbar('Unable to logout', {
//       //   variant: 'error'
//       // });
//     }
//   };

class Account extends Component {
  // const history = useHistory();
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    }
    this.settingsRef = React.createRef();
  }

  handleOpen = () => {
    this.setState({isOpen: true})
  };

  handleClose = () => {
    this.setState({isOpen: false})
  };

  logout = () => {
    window.location.replace('/auth/logout')
  }
  
  render(){
    let { user } = this.props
    let { isOpen } = this.state
    return (
      <div>
        <div style={{display: "flex",alignItems: "center"}}
          onClick={this.handleOpen}
          ref={this.settingsRef}
        > 
          <Hidden smDown>
            <Typography
              variant="body1"
              color="inherit"
            >
              
              {/* {user.email} */}
            </Typography>
          </Hidden>
          <div>
          <IconButton style={{color: '#000', padding: '6px'}}>
            {/* <Icon.Settings /> */}
            <AccountCircleOutlinedIcon sx={{color: 'rgb(111, 111, 111)'}}/>
          </IconButton>
            
          </div>
        </div>
        <Menu
        className="settings-menu"
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          keepMounted
          // PaperProps={{ className: classes.popover }}
          getContentAnchorEl={null}
          anchorEl={this.settingsRef.current}
          open={isOpen}
        >
          <MenuItem 
          onClick={this.logout}
          >
            Logout
          </MenuItem>
        </Menu>
      </div>
    );
  }
  
}

function mapStateToProps({app, user, brand}) {
  return {app, user, brand};
}

export default connect(mapStateToProps, {})(Account);



// WEBPACK FOOTER //
// ./src/containers/app/components/DashboardLayout/TopBar/Account.js